import React from "react";

function SearchButton() {
  return <button className="btn btn-warning pl-3 pr-3">Search</button>;
}

export default SearchButton;
